import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Tabs, Tab, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  iconError,
  paginationSet,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import {
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
// MUI
import { makeStyles, fade } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormHelperText,
} from "@material-ui/core";
import { createNumberSequence } from "./businessGroupAPI";
import {
  addNumberSequence,
  editNumberSequence,
  fetchIdNumberSequence,
  fetchNumberSequence,
  selectIdSequence,
} from "./businessGroupSlice";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const NumberSequenceCreate = ({
  isOpen,
  handleShow,
  setShow,
  dataRow,
  setDataRow,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const dataId = useSelector(selectIdSequence);

  const handleClose = () => {
    setFormValues({
      sequence_name: {
        value: "",
        error: false,
        required: "Y",
      },
      start_number: {
        value: "",
        error: false,
        required: "Y",
      },
      numerik_length: {
        value: "",
        error: false,
        required: "N",
      },
      reset_setting: {
        value: "Never",
        error: false,
        required: "N",
      },
    });
    setDataRow(null);
    setShow(false);
  };

  const [sequence_name, setSequence_name] = useState("");
  const [numerik_length, setNumerik_length] = useState("");
  const [start_number, setStart_number] = useState("");
  const [sequence_id, setSequence_id] = useState("");

  useEffect(() => {
    if (dataRow !== undefined && dataRow !== null) {
      setSequence_id(dataRow.sequence_id);
      setFormValues({
        sequence_name: {
          value: dataRow.sequence_name,
          error: false,
          required: "Y",
        },
        start_number: {
          value: dataRow.initial_num,
          error: false,
          required: "Y",
        },
        numerik_length: {
          value: dataRow.num_size,
          error: false,
          required: "Y",
        },
        reset_setting: {
          value: dataRow.reset_setting,
          error: false,
          required: "Y",
        },
      });
    }
  }, [dataRow]);

  // intiall
  const [formValues, setFormValues] = useState({
    sequence_name: {
      value: "",
      error: false,
      required: "Y",
    },
    start_number: {
      value: "",
      error: false,
      required: "Y",
    },
    numerik_length: {
      value: "",
      error: false,
      required: "Y",
    },
    reset_setting: {
      value: "Never",
      error: false,
      required: "Y",
    },
  });

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);
    return isValid;
  };

  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }
    const params = {
      sequence_name: formValues.sequence_name.value,
      initial_num: formValues.start_number.value,
      num_size: formValues.numerik_length.value,
      reset_setting: formValues.reset_setting.value,
    };

    const paramsEdit = {
      sequence_id: sequence_id,
      sequence_name: formValues.sequence_name.value,
      initial_num: formValues.start_number.value,
      num_size: formValues.numerik_length.value,
      reset_setting: formValues.reset_setting.value,
    };

    if (sequence_id === "") {
      try {
        const response = await dispatch(addNumberSequence(params));
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
            await dispatch(
              fetchNumberSequence({
                is_enable: "Y",
                pageNo: 1,
                pageSize: paginationSet,
              })
            );
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      try {
        const response = await dispatch(editNumberSequence(paramsEdit));
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
            await dispatch(
              fetchNumberSequence({
                is_enable: "Y",
                pageNo: 1,
                pageSize: paginationSet,
              })
            );
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    }
  };

  const [selectedValue, setSelectedValue] = useState("");

  const handleChangeReset = (event) => {
    const value = event.target.value;
    setFormValues({
      ...formValues,
      ["reset_setting"]: {
        ...formValues["reset_setting"],
        value,
      },
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  // const handleNumerikChange = (e) => {
  //   if (e === null) {
  //     e = undefined;
  //     setNumerik_length("");
  //   } else {
  //     setNumerik_length(e.target.value);
  //   }
  // };

  const handleNumerikChange = (e, numerik) => {
    const value = numerik.props.value;
    setFormValues({
      ...formValues,
      ["numerik_length"]: {
        ...formValues["numerik_length"],
        value,
      },
    });
  };

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={isOpen}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter text-white">
          {sequence_id === "" ? "New" : "Edit"} Number Sequence
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={12} sm={3} md={6} lg={6}>
            <RedditTextField
              required
              label="Sequence Name"
              className={classes.margin}
              variant="filled"
              id="reddit-input"
              size="small"
              fullWidth
              name="sequence_name"
              value={formValues.sequence_name.value}
              onChange={handleChange}
              error={formValues.sequence_name.error}
              helperText={
                formValues.sequence_name.error ? (
                  <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                    {iconError} {"This field is required"}
                  </FormHelperText>
                ) : (
                  ""
                )
              }
            />
            <TextField
              required
              select
              label="Numeric Length"
              className={classes.margin}
              value={formValues.numerik_length.value}
              onChange={handleNumerikChange}
              margin="normal"
              // variant="filled"
              // size="small"
              fullWidth
            >
              <MenuItem value="1">1</MenuItem>
              <MenuItem value="2">2</MenuItem>
              <MenuItem value="3">3</MenuItem>
              <MenuItem value="4">4</MenuItem>
              <MenuItem value="5">5</MenuItem>
            </TextField>
          </Col>
          <Col xs={12} sm={3} md={6} lg={6}>
            {" "}
            <RedditTextField
              required
              label="Start Number"
              className={classes.margin}
              variant="filled"
              id="reddit-input"
              size="small"
              type="number"
              fullWidth
              name="start_number"
              value={formValues.start_number.value}
              onChange={handleChange}
              error={formValues.start_number.error}
              helperText={
                formValues.start_number.error ? (
                  <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                    {iconError} {"This field is required"}
                  </FormHelperText>
                ) : (
                  ""
                )
              }
            />
            <div className="border-r">
              <p className="d-flex">
                Reset Setting <p className="color-red"> *</p>
              </p>
              <RadioGroup
                row
                value={formValues.reset_setting.value}
                onChange={handleChangeReset}
              >
                <FormControlLabel
                  value="Never"
                  control={<Radio />}
                  label="Never"
                />
                <FormControlLabel
                  value="Daily"
                  control={<Radio />}
                  label="Daily"
                />
                <FormControlLabel
                  value="Monthly"
                  control={<Radio />}
                  label="Monthly"
                />
                <FormControlLabel
                  value="Annually"
                  control={<Radio />}
                  label="Annually"
                />{" "}
                <FormControlLabel
                  value="Financial Year"
                  control={<Radio />}
                  label="Financial Year"
                />
              </RadioGroup>
            </div>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
